var _style, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path2, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHomeNetworkBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:url(#SVGID_1_);stroke-width:20;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill:url(#SVGID_17_);}\n\t.st17{fill:url(#SVGID_18_);}\n\t.st18{fill:url(#SVGID_19_);}\n\t.st19{fill:url(#SVGID_20_);}\n\t.st20{fill:url(#SVGID_21_);}\n\t.st21{fill:url(#SVGID_22_);}\n\t.st22{fill:url(#SVGID_23_);}\n\t.st23{fill:url(#SVGID_24_);}\n\t.st24{fill:url(#SVGID_25_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 285,
    x2: 256,
    y2: 513,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006DF0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392,219H120c-35.3,0-64-28.7-64-64c0-34.2,26.9-62.2,60.7-63.9C126.3,67.2,149.9,51,176,51 c6.8,0,13.4,1.1,19.8,3.2C215.3,27,246.4,11,280,11c48.6,0,90.7,34.2,101.3,80.9c3.5-0.6,7.1-0.9,10.7-0.9c35.3,0,64,28.7,64,64 S427.3,219,392,219z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 48,
    y1: 183,
    x2: 48,
    y2: 167,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 331,
    className: "st1",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 80,
    y1: 183,
    x2: 80,
    y2: 167,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 331,
    className: "st2",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 112,
    y1: 119,
    x2: 112,
    y2: 103,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 395,
    className: "st3",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 80,
    y1: 119,
    x2: 80,
    y2: 103,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 395,
    className: "st4",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 80,
    y1: 55,
    x2: 80,
    y2: 39,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CFF0"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 459,
    className: "st5",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 112,
    y1: 55,
    x2: 112,
    y2: 39,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CFF0"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 459,
    className: "st6",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 48,
    y1: 55,
    x2: 48,
    y2: 39,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CFF0"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 459,
    className: "st7",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 224,
    y1: 183,
    x2: 224,
    y2: 167,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 331,
    className: "st8",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 183,
    x2: 256,
    y2: 167,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 331,
    className: "st9",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 288,
    y1: 119,
    x2: 288,
    y2: 103,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 395,
    className: "st10",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 119,
    x2: 256,
    y2: 103,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 395,
    className: "st11",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 55,
    x2: 256,
    y2: 39,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CFF0"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 459,
    className: "st12",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 288,
    y1: 55,
    x2: 288,
    y2: 39,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CFF0"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 459,
    className: "st13",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 224,
    y1: 55,
    x2: 224,
    y2: 39,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CFF0"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 459,
    className: "st14",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 7,
    x2: 256,
    y2: 295,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A3F0"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M480,299h-40v-48H264v-32h-16v32H72v48H32c-13.2,0-24,10.8-24,24v160c0,13.2,10.8,24,24,24h96 c13.2,0,24-10.8,24-24V323c0-13.2-10.8-24-24-24H88v-32h160v32h-40c-13.2,0-24,10.8-24,24v160c0,13.2,10.8,24,24,24h96 c13.2,0,24-10.8,24-24V323c0-13.2-10.8-24-24-24h-40v-32h160v32h-40c-13.2,0-24,10.8-24,24v160c0,13.2,10.8,24,24,24h96 c13.2,0,24-10.8,24-24V323C504,309.8,493.2,299,480,299z M24,379h112v48H24V379z M128,491H32c-4.4,0-8-3.6-8-8v-40h112v40 C136,487.4,132.4,491,128,491z M136,323v40H24v-40c0-4.4,3.6-8,8-8h96C132.4,315,136,318.6,136,323z M200,379h112v48H200V379z  M304,491h-96c-4.4,0-8-3.6-8-8v-40h112v40C312,487.4,308.4,491,304,491z M312,323v40H200v-40c0-4.4,3.6-8,8-8h96 C308.4,315,312,318.6,312,323z M384,315h96c4.4,0,8,3.6,8,8v40H376v-40C376,318.6,379.6,315,384,315z M488,379v48H376v-48H488z  M480,491h-96c-4.4,0-8-3.6-8-8v-40h112v40C488,487.4,484.4,491,480,491z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 400,
    y1: 183,
    x2: 400,
    y2: 167,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 331,
    className: "st16",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 432,
    y1: 183,
    x2: 432,
    y2: 167,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 331,
    className: "st17",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 464,
    y1: 119,
    x2: 464,
    y2: 103,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 395,
    className: "st18",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 432,
    y1: 119,
    x2: 432,
    y2: 103,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009AF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 395,
    className: "st19",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 432,
    y1: 55,
    x2: 432,
    y2: 39,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CFF0"
    }
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 459,
    className: "st20",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 464,
    y1: 55,
    x2: 464,
    y2: 39,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CFF0"
    }
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 459,
    className: "st21",
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 400,
    y1: 55,
    x2: 400,
    y2: 39,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CFF0"
    }
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 459,
    className: "st22",
    width: 16,
    height: 16
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.9,
    y1: 43.025,
    x2: 279.9,
    y2: 75.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A9F0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M319.5,75.4l11.3-11.3c-28-28.1-73.7-28.1-101.8,0l11.3,11.3C262.2,53.6,297.7,53.6,319.5,75.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.9,
    y1: 327,
    x2: 408.9,
    y2: 391,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006DF0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M424.9,155c0-17.6-14.4-32-32-32v16c8.8,0,16,7.2,16,16s-7.2,16-16,16v16C410.6,187,424.9,172.7,424.9,155z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeNetworkBlue);
export default __webpack_public_path__ + "static/media/icon-home-network-blue.e42ecfbaf650322472c425a386ee9a95.svg";
export { ForwardRef as ReactComponent };